// Firebase SDK

export const firebaseConfig = {
  apiKey: "AIzaSyC7IFG6JRiXEVR3_nk0xyT4HZXpnb3FJxI",
  authDomain: "masatdev.firebaseapp.com",
  databaseURL: "https://masatdev.firebaseio.com",
  projectId: "masatdev",
  storageBucket: "masatdev.appspot.com",
  messagingSenderId: "639195476761",
  appId: "1:639195476761:web:2c0b53e257a1518dba4b88"
};
